import { useReactiveVar } from "@apollo/client";
import {
  GetNotificationsDocument,
  GetNotificationsQuery,
  NotificationOutput,
  NotificationSubtype,
  QueryGetNotificationsArgs,
  useWatchNotificationsSubscription,
} from "~@/graphql/codegen/generated";
import { unreadNotificationsCountVar } from "~@/reactive-variables";

// Хук для подписки на уведомления
const useWatchNotifications = (userId: string) => {
  const unreadNotificationsCount = useReactiveVar(unreadNotificationsCountVar);

  // Подписка на уведомления
  useWatchNotificationsSubscription({
    skip: !userId, // Пропускаем подписку, если нет идентификатора пользователя
    variables: { userId }, // Передаем идентификатор пользователя
    onData({ data: newNotification, client: { cache } }) {
      const notification = newNotification.data?.watchNotifications; // Получаем данные нового уведомления

      // Если тип уведомления не TaskReminded и не TaskCreated, обновляем кэш для всех уведомлений
      if (
        notification?.subtype !== NotificationSubtype.TaskReminded &&
        notification?.subtype !== NotificationSubtype.TaskCreated
      ) {
        cache.updateQuery<GetNotificationsQuery, QueryGetNotificationsArgs>(
          {
            query: GetNotificationsDocument,
            variables: { onlyTasks: false, fetchSize: 20 }, // Запрашиваем уведомления с указанными параметрами
          },
          (data) => {
            if (data && data.getNotifications && notification) {
              return {
                getNotifications: {
                  ...data.getNotifications,
                  notifications: [
                    notification,
                    ...(data?.getNotifications
                      ?.notifications as NotificationOutput[]), // Добавляем новое уведомление в начало списка
                  ],
                  // Обновляем количество непрочитанных уведомлений
                  unreadCount:
                    unreadNotificationsCount + (notification?.isRead ? -1 : 1),
                },
              };
            }

            return data; // Возвращаем данные без изменений, если условия не выполнены
          }
        );
      } else {
        // Обновляем кэш для уведомлений типа TaskReminded и TaskCreated для обоих значений onlyTasks
        for (let i of [true, false]) {
          cache.updateQuery<GetNotificationsQuery, QueryGetNotificationsArgs>(
            {
              query: GetNotificationsDocument,
              variables: { onlyTasks: i, fetchSize: 20 }, // Запрашиваем уведомления с указанными параметрами
            },
            (data) => {
              if (data && data.getNotifications && notification) {
                return {
                  getNotifications: {
                    ...data.getNotifications,
                    notifications: [
                      notification,
                      ...(data?.getNotifications
                        ?.notifications as NotificationOutput[]), // Добавляем новое уведомление в начало списка
                    ],
                    // Обновляем количество непрочитанных уведомлений
                    unreadCount:
                      unreadNotificationsCount +
                      (notification?.isRead ? -1 : 1),
                  },
                };
              }

              return data; // Возвращаем данные без изменений, если условия не выполнены
            }
          );
        }
      }
    },
  });
};

export default useWatchNotifications;
